var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 50,
    viewBox: "0 0 68 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 50,
    rx: 4,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4318 40.3981C50.4318 40.1903 50.168 40.1279 50.168 40.1279C47.5304 39.6398 45.0679 37.8039 43.2052 35.8422C40.639 33.0783 38.4244 30.0077 36.612 26.7002C36.3185 26.018 36.7373 25.9454 36.7373 25.9454C41.8773 23.9675 42.7243 18.8344 42.7243 17.43C42.7175 10.9222 36.5593 9 31.0077 9C28.9143 9 28.2122 9.17459 26.0296 9.17459C23.491 9.17459 21.9647 9 21.5727 9C21.4912 9.00369 21.4113 9.02395 21.338 9.05955C21.2646 9.09515 21.1993 9.14533 21.146 9.20704C21.0926 9.26874 21.0525 9.34067 21.0279 9.41843C21.0033 9.49619 20.9948 9.57814 21.003 9.65928C21.003 11.2285 24.5866 8.56161 24.5866 13.8065V34.7343C24.5857 39.585 21.1768 38.2321 21.1768 39.4121C21.1768 39.8076 21.6117 39.9363 21.8726 39.9363C23.1418 39.9363 24.5823 39.7617 26.6362 39.7617C29.2176 39.7617 29.8701 39.9363 31.3569 39.9363C32.4482 39.9363 32.6228 39.7188 32.6228 39.4121C32.6228 37.9288 28.035 40.2001 28.035 33.9068V11.8419C28.035 10.525 28.9976 10.525 30.3956 10.525C35.4196 10.525 39.3957 13.324 39.4815 18.6084C39.5409 22.1919 36.8439 25.5941 32.4036 25.5941C31.8765 25.617 31.3484 25.5861 30.8276 25.5019C30.6101 25.5019 30.3892 25.5911 30.3892 25.8944C30.3892 26.2933 30.7189 26.501 31.0914 26.6097C32.2687 26.9526 33.2672 27.7384 33.8772 28.8021V28.8021C36.8444 33.6813 40.2066 41 47.8528 41C50.7142 41 50.4241 40.6704 50.4241 40.4002",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHorizontal);
export default __webpack_public_path__ + "static/media/empty-horizontal.527bed84be3204383e25ab2d3124098d.svg";
export { ForwardRef as ReactComponent };